import React, { memo } from "react";
import { isEditMode } from "../../../utils/isEditMode/isEditMode";
import Container from "../Container/Container";
import Grid from "../Grid/Grid";
import Col from "../Col/Col";

interface FallbackComponentProps {}

const FallbackComponent: React.FC<FallbackComponentProps> = (props) => {
  if (isEditMode()) {
    return (
      <section>
        <Container>
          <Grid>
            <Col
              span={{ md: 10, lg: 8, xl: 6 }}
              start={{ md: 2, lg: 3, xl: 4 }}
            >
              <p>Blok doesn't exist</p>
            </Col>
          </Grid>
        </Container>
      </section>
    );
  }

  return null;
};

export default memo(FallbackComponent);
